import React, { FC } from 'react';

import type { ChangeInputHandler } from '../../types';
import type { FreeBet } from 'app/api/services/freebets/types';
import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';

import { AccountType } from '../../constants';
import type { PledgeStakeDAO } from '../../types/backend/paymentOptions';
import FreeBetAccount from './components/FreeBetAccount';
import MainAccount from './components/MainAccount';
import { AccountSelectProps } from './components/MainAccount/AccountSelect';
import { MainAccountWithoutChain } from './components/MainAccountWihoutDropdown';
import PledgeStakeAccount from './components/PledgeStakeAccount';

// ---

type AmountInputByAccountTypeProps = {
  betId?: number;
  name: string;
  account: AccountType;
  placeholder: string;
  value: string;
  minValue?: number;
  onChange: ChangeInputHandler;
  error?: boolean;
  className?: string;
  pledgeStake?: PledgeStakeDAO | null;
  freeBet?: FreeBet | null;
  disabledTitle: AccountSelectProps['disabledTitle'];
};

const AmountInputByAccountType: FC<AmountInputByAccountTypeProps> = ({
  betId,
  name,
  account,
  placeholder,
  value,
  minValue,
  onChange,
  error,
  className,
  pledgeStake,
  freeBet,
  disabledTitle,
}) => {
  const isAllowChain = useFeatureFlag(FeatureFlag.CHAIN);

  const mainAccount = isAllowChain ? (
    <MainAccount betId={betId}
                 account={account}
                 placeholder={placeholder}
                 error={error}
                 className={className}
                 inputProps={{ onChange, name, value }}
                 disabledTitle={disabledTitle} />
  ) : (
    <MainAccountWithoutChain betId={betId}
                             account={account}
                             placeholder={placeholder}
                             error={error}
                             className={className}
                             inputProps={{ onChange, name, value }} />
  );

  return (
    <>
      {account === AccountType.MAIN_ACCOUNT && (
        <>{mainAccount}</>
      )}

      {account === AccountType.PLEDGE_STAKE_ACCOUNT && (
        <PledgeStakeAccount betId={betId}
                            value={pledgeStake}
                            minValue={minValue}
                            placeholder={placeholder}
                            error={error}
                            inputProps={{ onChange, name, value }} />
      )}

      {account === AccountType.FREE_BET_ACCOUNT && (
        <FreeBetAccount betId={betId}
                        value={freeBet}
                        inputProps={{ onChange, name, value }} />
      )}
    </>
  );
};

export default AmountInputByAccountType;
